import { put, takeEvery } from 'redux-saga/effects';
import { call } from 'typed-redux-saga';
import { IMoveShipmentRequest, LogisticsActionKeys, MoveShipmentItems } from '..';
import { httpService } from '../../..';
import { IEntityWithMessages } from '../../../services/HttpService';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { ApiUrls } from '../../ApiUrls';
import { executeApiRequest } from '../../asyncUtils';
import { processMessages, showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import { logisticsActionCreators } from '../logisticsActionCreators';
import { IMoveShipmentItemResponse } from '../logisticsInterfaces';

function* moveShipmentItemsSaga(action: MoveShipmentItems) {
  yield put(uiActionCreators.showSpinnerDialog());
  const response = yield* call(executeMove, action.payload);

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else if (response.value) {
    yield processMessages(response.value);

    if (response.value.value) {
      if (response.value.value.shipmentContainer) {
        yield put(logisticsActionCreators.setContainer(response.value.value.shipmentContainer));
      }

      yield put(logisticsActionCreators.setShipmentItems(response.value.value.shipmentItems));
    }
  }

  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchMoveShipmentItems() {
  yield takeEvery(LogisticsActionKeys.MOVE_SHIPMENT_ITEMS, moveShipmentItemsSaga);
}

async function executeMove(
  update: IMoveShipmentRequest
): Promise<IApiExecuteRespone<IEntityWithMessages<IMoveShipmentItemResponse>>> {
  return executeApiRequest(() => httpService.post(`${ApiUrls.shipment()}/Containers`, update));
}
